import React from 'react';
import { useTranslation } from 'react-i18next';
import StackedPercentageAreaChart from '../../charts/StackedPercentageAreaChart';
import { useMemo } from 'react';
import BlockChart from '../../BlockChart';
import { dataToStackChartData } from '../../../services/data/charts/dataToStackChartData';

const ConsentRequestLayoutVersionByDayChart = ({data = [], isSuccess, isFetching: isLoading, refetch}) => {
  const { t } = useTranslation();
  const formattedData = useMemo(() => dataToStackChartData("consent_request_layout_version", "count")(data), [data] )
  return (
    <BlockChart title={t("cmp.analytics.consentRequestsByLayoutByDay")} isLoading={isLoading} isSuccess={isSuccess}>
      <StackedPercentageAreaChart data={formattedData} legendOptions={{show: false}}/>
    </BlockChart>
  )
}

export default ConsentRequestLayoutVersionByDayChart
